import * as React from 'react';
import { SingleSelectInput } from '@cxc/react-fpds-components';
import { DropdownOnChangeEventProps, DropdownProps } from '../../types/props/DropdownProps';

const Dropdown: React.FC<DropdownProps> = (props) => {
    const handleSingleOptionSelect = (param: DropdownOnChangeEventProps) => {
        props.onChange(param.value);
    };

    return (
        <div>
            <SingleSelectInput
                placeholder={props.placeholder ? props.placeholder : props.options[0].label}
                isRequired={props.isRequired}
                showClear={props.showClear}
                options={props.options}
                selected={props.selected}
                onOptionSelect={handleSingleOptionSelect}
                labelProp={{
                    label: props.label,
                }}
                infoProp={{
                    infoText: props.tooltip,
                }}
                size="small"
                data-testid={props.dataTestId}
            />
        </div>
    );
};

export default Dropdown;
